<template>
  <div id="Products">
    <div id="overlay2" @click="off">
      
      <div id="text">

        
        <b-img :src='mySrc' id="bigImg"></b-img>
      </div>
    </div>
    <!-- As a heading -->
    
    <div class="beforesvg">
      
      <button @click='show?show=false:show=true' id="makeBounce" style="display:none;">clickme</button>
      <b-container fluid class="p-4 bg-dark">
        
        <center><h1 id="heading">RECENT PROJECTS</h1></center>
      <b-row>
        
        <b-col sm="4"  v-for="(img,index) in Data" :key="index" >
          
          <transition name='bounce'>
            
            <b-img @click="on(index)" v-if='show && (showAll||(index==0||index==1||index==2))' fluid height="40%" :src="img.url" alt="Image 1" class="eachProduct zoom">
              
            </b-img>
            
            
            
           
            
          </transition>
          
        </b-col>
        
      </b-row>
      <b-icon class="viewMore" v-if='show && !showAll' @click='showAll=true' icon="chevron-compact-down"></b-icon>
      <b-icon class="viewMore" v-if='show && showAll' @click='showAll=false' icon="chevron-compact-up"></b-icon>
    </b-container>
     <svg id="theSVG" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#343A40" fill-opacity="1" d="M0,0L80,26.7C160,53,320,107,480,138.7C640,171,800,181,960,197.3C1120,213,1280,235,1360,245.3L1440,256L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>
     <div id="footer" style="margin-top:-30px;">
        <b-row>
        
        <b-col sm="4">
            
        </b-col>
        <b-col sm="4">
          Created with Love by <a id="myName" href="tel:Whatsapp:9714275943">Yunus</a>
        </b-col>
        <b-col sm="4">
          Copyright © 2020
        </b-col>

        </b-row>
        
     </div>
     
     
    </div>
  </div>
  
</template>

<script>
export default {
  props: {
      myproducts:String,
  },
  data(){
      return{
        show:false,
        showAll:false,
         Data:[
        {url:require("@/assets/GG.jpg")},
        {url:require("@/assets/Aashiv Logo.jpg")},
        {url:require("@/assets/HET.jpg")},
        {url:require("@/assets/EK Dant Card.jpg")},
        {url:require("@/assets/EK Dant Logo.jpg")},
        {url:require("@/assets/Jacqnarc-Banner.jpg")},
        {url:require("@/assets/PG.jpg")},
        {url:require("@/assets/PUBG Girl.jpg")},
        {url:require("@/assets/Vaishvi Soni tran.png")},
        {url:require("@/assets/VIREN DARJI.jpg")}

        ],
        mySrc:'',
      }
          
  },
  methods:{
    showImage(value){
       alert(`${this.Data[value].price}`);
    },
     on:function(value) {
      document.getElementById("overlay2").style.display = "block";
      this.mySrc=this.Data[value].url;

    },
      off:function() {
        document.getElementById("overlay2").style.display = "none";
      } ,
  },
  mounted(){
    document.getElementById('makeBounce').click();
    document.addEventListener('contextmenu',event => event.preventDefault());
  }
  

}
     
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html,body
{
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    overflow-x: hidden; 
}
#bigImg{
  margin-top: 250px;
  width: 70%;
}
#overlay2 {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.9); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  #myName{
    color: #18A2B8;
  }
  #theSVG{
    transform: rotate(180deg);

  }
 .bounce-enter-active{
   animation: bounce-in .5s;
 }
 .bounce-leave-active{
  
   animation: fadeOut .5s ;
   display: none;
 }
 .eachProduct{
   margin-bottom:15px;
 }
 .eachProduct:hover{
   cursor: pointer;
   
   
 }
 .viewMore{
   color:white; height:15%; width:15%;
   transition: transform .5s, filter 1.5s ease-in-out;
 }
 .viewMore:hover{
   transform: scale(1.7);
   cursor: pointer;
 }
 .zoom:hover {
  filter: grayscale(0);
  transform: scale(1.1);
  
}
 .zoom {
  
   /*transition: transform .2s;*/
  /* margin: 0 auto; */
  transition: transform .5s, filter 1.5s ease-in-out;
  filter: grayscale(100%);
}

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50%{
      transform: scale(1.2);
    }
    100%{
      transform: scale(1);
    }
    
  }
  @keyframes fadeOut {
   0% {opacity: 1;}
   100% {opacity: 0;} 
  } 
  #heading{
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color:white;
    margin-bottom: 20px;
    font-size: 110%;
  }
  @media only screen and (min-width: 768px) {
  /* For desktop: */
  #bigImg{

  margin-top: 40px;
  height:500%;
}
    #heading{
      font-size:210%;
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color:white;
      margin-bottom: 20px;
    }
    .viewMore{
        color:white; height:5%; width:5%;
        transition: transform .5s, filter 1.5s ease-in-out;
      }
  }
  


</style>
